import { fetchAnalysisFilters, updateAnalysisView } from "@actions";
import { confirmModal } from "@actions/modals";
import ExpandButton from "@buttons/ExpandButton";
import { connect } from "react-redux";
import OrgTreeButton from "../buttons/OrgTreeButton.js";
import DownloadButton from "../buttons/DownloadButton.js";
import SummaryButton from "../buttons/SummaryButton.js";
import React from "react";

const AnalysisButtons = (props) => {
  const {
    downloadLoading,
    hideGraph,
    hideFilters,
  } = props.analysis;

  const { showOrgTree } = props.analysisFilters;
  const disabled = !props.analysisFilters.hasSelection;

  return <div>
    <SummaryButton
      active={hideFilters}
      onClick={() => props.updateAnalysisView({ hideFilters: !hideFilters })}
      size="medium"
    />
    <OrgTreeButton
      active={showOrgTree}
      onClick={() =>
        props.fetchAnalysisFilters({ showOrgTree: !showOrgTree })
      }
    />
    <DownloadButton
      onClick={props.onExport}
      loading={downloadLoading}
      disabled={disabled}
      compact={false}
      size="medium"
    />
    <ExpandButton
      compact={false}
      floated={false}
      active={hideGraph}
      size="medium"
      onClick={() => props.updateAnalysisView({ hideGraph: !hideGraph })}
    />
  </div>
}


const mapStateToProps = (state) => {
  return {
    analysis: state.analysisView,
    analysisFilters: state.analysisFilters,
  };
};

export default connect(mapStateToProps, {
  updateAnalysisView,
  fetchAnalysisFilters,
  confirmModal,
})(AnalysisButtons);
